var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.08334C6.75629 2.08334 2.08337 6.75626 2.08337 12.5C2.08337 18.2438 6.75629 22.9167 12.5 22.9167C18.2438 22.9167 22.9167 18.2438 22.9167 12.5C22.9167 6.75626 18.2438 2.08334 12.5 2.08334ZM12.5 20.8333C7.90525 20.8333 4.16671 17.0948 4.16671 12.5C4.16671 7.90522 7.90525 4.16668 12.5 4.16668C17.0948 4.16668 20.8334 7.90522 20.8334 12.5C20.8334 17.0948 17.0948 20.8333 12.5 20.8333Z",
    fill: "#374151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5417 7.29166H11.4584V12.9312L14.8886 16.3614L16.3615 14.8885L13.5417 12.0687V7.29166Z",
    fill: "#374151"
  })));
};
export default SvgClock;